import { HelmetProvider } from 'react-helmet-async';

import { AppRoutes } from '@/routes';
import { ThemeProvider } from '@/theme';

export function App() {
  return (
    <HelmetProvider>
      <ThemeProvider>
        <AppRoutes />
      </ThemeProvider>
    </HelmetProvider>
  );
}
